import React, { useState, useEffect } from 'react'
import axiosInstance from '../../apis/axiosInstance'

function Aditya() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get('/aditya')
        setData(response.data)
      } catch (error) {
        console.error('Error fetching Aditya data:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  if (loading) return <div className="text-center py-10">Loading...</div>

  return (
    <div>
      Aditya
    </div>
  )
}

export default Aditya
